export { THScanAndPayContainer as THScanAndPay } from './th-scan-and-pay';
